import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

type PipelineStage =
  DashboardApi20240730.GetIntegration.HubSpotIntegration['pipelineStages'][number]

/**
 * Stages from all of an account's pipelines share one list, and two pipelines
 * can each have a stage with the same name. Returns the pipeline label only
 * where the stage label repeats, so unique names stay uncluttered.
 */
export const disambiguatingPipelineLabel = (stages: PipelineStage[]) => {
  const countByLabel = stages.reduce(
    (counts, stage) =>
      counts.set(stage.label, (counts.get(stage.label) ?? 0) + 1),
    new Map<string, number>()
  )

  return (stage: PipelineStage): string | undefined =>
    (countByLabel.get(stage.label) ?? 0) > 1 ? stage.pipelineLabel : undefined
}

/** A stage label for inline copy, e.g. "Closed Won (Enterprise)". */
export const pipelineStageDisplayLabels = (
  stages: PipelineStage[]
): Map<string, string> => {
  const pipelineLabelFor = disambiguatingPipelineLabel(stages)

  return new Map(
    stages.map(stage => {
      const pipelineLabel = pipelineLabelFor(stage)
      return [
        stage.id,
        pipelineLabel ? `${stage.label} (${pipelineLabel})` : stage.label
      ] as const
    })
  )
}
